import { EmissionSourceTypeCat3_5 } from '@/app/org-cfv/src/enums/EmissionSourceEnum';
import { PaginationMeta } from '@/typings/api';
import { ButtonLoadingState } from '@/typings/common';

export enum FE_LANG {
  EN_US = 'en-US',
  ZH_TW = 'zh-TW',
  ZH_CN = 'zh-CN',
}

export enum BE_LANG {
  EN_US = 'en_us',
  ZH_TW = 'zh_tw',
}

export enum Country {
  TW = 'TW',
}

export const REDIRECT_URL_KEY = 'redirect_url';

export const CONTACT_US_EMAIL = 'support@cedarsdigital.io';

export const DEFAULT_META: PaginationMeta = {
  page: 1,
  take: 10,
  itemCount: 0,
  pageCount: 0,
  hasPreviousPage: false,
  hasNextPage: false,
};

export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];
export const INIT_PAGINATION = {
  pageIndex: 0,
  pageSize: PAGE_SIZE_OPTIONS[0],
};

export const SCROLL_TO_KEY = 'scrollTo';

export const BULK_INPUT_ROW_LIMIT = 10000;
export const BULK_INPUT_PROCESS_LIMIT_RATIO = 0.5;
export const BULK_INPUT_PROCESS_FAKE_DELTA = 0.5;
export const progressLimit = (currentProgress: number) => {
  return Math.min(currentProgress, 99);
};

export const RECALCULATING_WARNING_TOAST_ID = 'recalculating-warning-toast-id';

export const OTHER = {
  PROCESS_OTHER: 'PROCESS_OTHER',
  PERMP_OTHER: 'PERMP_OTHER',
  INDUSTRY_TYPE_OTHER: 'INDUSTRY_TYPE_OTHER',
  FACTOR_SOURCE_OTHER: 'FACTOR_SOURCE_OTHER',

  FT_OTHER: 'FT_OTHER',
  OT_OTHER: 'OT_OTHER',
};

export const CO2E = 'CO2E';

export const RAW_MATERIAL = {
  BIOFUEL: 'BIOFUEL',
};

export const BUSINESS_TRIP_TYPE_TO_I18N_KEY: { [key: string]: string } = {
  [EmissionSourceTypeCat3_5.TRANSPORTATION]: 'org-cfv-data-entry.businessTravelTransportation',
  [EmissionSourceTypeCat3_5.ACCOMMODATION]: 'org-cfv-data-entry.businessTravelAccommodation',
};

export const DEFAULT_BUTTON_LOADING_STATE: ButtonLoadingState = {
  isBulkSubmitting: false,
  isBulkRemoving: false,
  isSubmitting: false,
  isRemoving: false,
  id: undefined,
};

export enum SESSION_STORAGE_KEY {
  CFP_DATA_ENTRY_LIST = 'cfp-data-entry-list',
  CFP_DATA_QUALITY_LIST = 'cfp-data-quality-list',
  BOUNDARY_PROJECT_LIST = 'boundary-project-list',
}
